<div id="content" class="border">
  <router-outlet></router-outlet>
</div>